import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/main.css';
import './assets/css/button.css';

createApp(App).mount('#app')
